import { NgModule } from "@angular/core";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxSpinnerModule } from 'ngx-spinner';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { FileUploadModule } from 'ng2-file-upload';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgxDocViewerModule } from 'ngx-doc-viewer2';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCurrencyFormatModule } from 'mat-currency-format';
import { CustomFormsModule } from 'ngx-custom-validators';
import { ArchwizardModule } from 'angular-archwizard';
import { TagInputModule } from 'ngx-chips';
import { QuillModule } from 'ngx-quill'
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { InputMaskModule } from "@ngneat/input-mask";
import { AngularWebStorageModule } from "angular-web-storage";
import { SwiperModule } from "ngx-swiper-wrapper";
import { PipeModule } from "app/shared/pipes/pipe.module";
import { AngularMaterialModule } from "app/angular-material/angular-material.module";
import { ChartistModule } from "ng-chartist";
import { MatchHeightModule } from "app/shared/directives/match-height.directive";
import { NouisliderModule } from "ng2-nouislider";
import { PickerModule } from "@ctrl/ngx-emoji-mart";
import { NgApexchartsModule } from "ng-apexcharts";
import { AngularResizeEventModule } from "angular-resize-event";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { OverlayModule } from "@angular/cdk/overlay";
import { ClickOutsideModule } from "ng-click-outside";
import { AutocompleteModule } from "app/shared/components/autocomplete/autocomplete.module";
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

@NgModule({
    imports: [
        NgbModule,
        FormsModule,        
        ReactiveFormsModule,
        RouterModule,
        NgxSpinnerModule,
        TranslateModule,
        FileUploadModule,
        PerfectScrollbarModule,
        UiSwitchModule,
        NgxDocViewerModule,
        NgSelectModule,
        MatCurrencyFormatModule,
        CustomFormsModule,
        ArchwizardModule,        
        TagInputModule,
        QuillModule.forRoot(),        
        NgxDatatableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        ImageCropperModule,
        NgxChartsModule,
        InputMaskModule,
        AngularWebStorageModule,
        SwiperModule,
        PipeModule,
        AngularMaterialModule,
        ChartistModule,
        MatchHeightModule,
        NouisliderModule,
        PickerModule,
        NgApexchartsModule,
        AngularResizeEventModule,
        ScrollingModule,
        OverlayModule,
        ClickOutsideModule,
        AutocompleteModule,
        LeafletModule,
        NgbNavModule
    ],
    exports: [
        NgbModule,
        FormsModule,        
        ReactiveFormsModule,
        RouterModule,
        NgxSpinnerModule,
        TranslateModule,
        FileUploadModule,
        PerfectScrollbarModule,
        UiSwitchModule,
        NgxDocViewerModule,
        NgSelectModule,
        MatCurrencyFormatModule,
        CustomFormsModule,
        ArchwizardModule,        
        TagInputModule,
        NgxDatatableModule,
        MatDatepickerModule,
        MatNativeDateModule,        
        ImageCropperModule,
        NgxChartsModule,
        InputMaskModule,
        AngularWebStorageModule,
        SwiperModule,
        PipeModule,
        AngularMaterialModule,
        ChartistModule,
        MatchHeightModule,
        NouisliderModule,
        PickerModule,
        NgApexchartsModule,
        AngularResizeEventModule,
        ScrollingModule,
        OverlayModule,
        ClickOutsideModule,
        AutocompleteModule,
        LeafletModule,
        NgbNavModule
    ]
})

export class ImportsModule { }